// @ts-nocheck
import { get } from './utils/api/base';
const API_URL = process.env.REACT_APP_BASE_API_URL || 'http://localhost:3500';
/**
 * @typedef {Object} Rota
 * @property {string|number} CodigoIntegracao - Codigo de integracao da rota
 * @property {string} Descricao - Descricao da rota
 * @property {number} [Ativo] - Status ativo (1/0)
 */
/**
 * @typedef {Object} RotasFilters
 * @property {string} [CodigoIntegracao] - Filtro por codigo de integracao (busca exata)
 * @property {string} [Descricao] - Filtro por descricao (busca LIKE)
 * @property {number} [Ativo] - Filtro por status ativo (1/0)
 * @property {number} [pagina] - Numero da pagina
 * @property {number} [quantidadePorPagina] - Quantidade de registros por pagina
 */
/**
 * @typedef {Object} RotasResponse
 * @property {Rota[]} registros - Lista de rotas
 * @property {number} totalRegistros - Total de registros encontrados
 * @property {number} paginaAtual - Pagina atual
 * @property {number} quantidadePorPagina - Quantidade de registros por pagina
 */
/**
 * Lista rotas com filtros e paginacao
 * @param {RotasFilters} filters - Filtros para a busca
 * @returns {Promise<RotasResponse>} Resposta com lista de rotas
 */
export const getRotas = async (filters = {}) => {
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            queryParams.append(key, String(value));
        }
    });
    const url = `${API_URL}/rotas?${queryParams.toString()}`;
    const response = await get(url);
    return response?.data || response || {};
};
